// zh_cn.js简体文件
export default {
	message: {
		language: '语言',
		plogin: '请先登录！',
		login: '登录',
		login1: '立即登录',
		logintips: '登录后体验更多服务',
		register: '注册',
		register1: '立即注册',
		loginout: '退出',
		join: '加入',
		days: '天',
		lastip: '上次登录IP',
		account: '账号',
		game: '游戏',
		video: '视频',
		collect: '收藏',
		Favorite: '已收藏',
		collect1: '收藏夹',
		share: '分享',
		sharelive: '分享直播',
		Cache: '缓存',
		download: '下载',
		wallet: '钱包',
		recharge: '充值',
		withdraw: '提现',
		noble: '贵族',
		record: '记录',
		RechargeTime: '充值时间',
		WithdrawalTime: '提现时间',
		RechargeRecord: '充值记录',
		WithdrawalRecords: '提现记录',
		TransactionRecords: '交易记录',
		business: '商务',
		message: '消息',
		activity: '优惠',
		setting: '设置',
		help: '帮助',
		version: '版本',
		loggingout: '退出登录',
		remember: '记住密码',
		forget: '忘记密码',
		noaccount: '没有账号',
		returnhome: '返回首页',
		bottomtips: '本集团受菲律宾PAGCOR 及 英国马恩岛博彩协会监管合法运营',
		days21: '已满21周岁，并且阅读及同意',
		rules: '规则与条款',
		hadaccount: '已有账号',
		gonggao: '公告',
		system: '系统',
		home: '首页',
		kefu: '客服',
		kefuCenter: '客服中心',
		mykf1desc: '请下载以下专属APP添加ID与我联系',
		mykf2desc: '下载地址',
		mykf3desc1: '在线客服',
		mykf3desc2: '点击开始在线聊天',
		mykf3desc3: '处理充值不到账，提现以及游戏问题',
		my: '我的',
		close: '关闭',
		zuixin: '最新',
		yhdetail: '优惠详情',
		mywallet: '我的钱包',
		zichan: '资产',
		yuan: '元',
		zxwallet: '中心钱包',
		ptwallet: '平台钱包',
		transfer: '转账',
		LimitTransfer: '额度转账',
		cards: '卡包管理',
		gamebalance: '游戏余额',
		onerecycle: '一键回收',
		Recovery: '回收金额',
		Recycling: '回收中',
		wei: '维',
		loading: '加载中',
		refreshing: '刷新中',
		refreshend: '刷新成功',
		success: '操作成功',
		czamount: '充值金额',
		limit: '限额',
		saccount: '选择账户',
		skbank: '收款银行',
		skname: '收款姓名',
		copy: '复制',
		skcard: '收款卡号',
		submit: '提交',
		Confirmsubmit: '确认提交',
		nextstep: '下一步',
		customerservice: '人工客服',
		pleasecontact: '如果您有任何问题，请联系',
		copysuccess: '已成功复制到剪切板',
		copyfail: '复制失败',
		firstmoney: '请先输入充值金额',
		rechargelowtips: '充值金额不能小于最低限额',
		rechargeuptips: '充值金额不能大于最高限额',
		firstaccount: '请先选择账户',
		selwallet: '选择钱包',
		firstoutwallet: '请先选择转出钱包',
		retract: '收起',
		expend: '展开',
		mzmodel: '免转模式',
		mzmodeltips: '开启后余额自动转入游戏场馆',
		seloutwallet: '选择转出钱包',
		selinwallet: '选择转入钱包',
		transfertips: '场馆钱包之间不可以互转',
		maxamount: '最大金额',
		codings: '打码量',
		washingAmount: '洗码量',
		withamount: '提现金额',
		banks: '银行卡',
		withzhtips: '请先绑定提现账户',
		withmoneytips: '请先输入提现金额',
		add: '添加',
		antoken1: '全球领先的虚拟币在线钱包，充值提现自动实时到账，转账交易更快捷，更安全',
		antoken2: 'AnToken个人钱包APP下载：点击直接访问 网址',
		antoken3: 'https://antoken.pro',
		cardtips: '温馨提示：每个账户只能绑定5张，如若修改请删除后重新添加！',
		walletaddress: '钱包地址',
		walletaddressdesc: '请填写ec开头 34位英数组合的K豆地址',
		USDTaddress: 'USDT地址',
		unbindingtips: '确定要解绑吗？',
		paypass: '支付密码',
		cardprotocol: '钱包协议',
		cardaddress: '钱包地址',
		Cardholder: '持卡人',
		bankcard: '银行卡号',
		bankname: '开户银行',
		banknamedesc: '请选择开户银行',
		bankaddress: '开户地址',
		bankaddressdesc: '请选择开户地址',
		bankother: '开户支行',
		firstpaypass: '请输入支付密码',
		bindtips: '请妥善填写信息，绑定后不可修改',
		Paymentcode: '收款码',
		platname: '腾达娱乐',
		records: '充提记录',
		gameRecord: '游戏记录',
		betrecord: '游戏注单',
		betDetail: '下注详情',
		accountsetting: '账户设置',
		messages: '我的消息',
		returnrecord: '返水记录',
		transferrecord: '转账记录',
		activityrecord: '活动申请记录',
		applyfor: '申请',
		welfare: '红包',
		query: '查询',
		Time: '时间',
		To: '至',
		dllogin: '代理登录',
		outsuccess: '退出成功',
		today: '今日',
		days7: '近7日',
		days14: '近14日',
		days30: '近30日',
		cunkuan: '存款',
		qukuan: '取款',
		ordersn: '订单号',
		money: '金额',
		state: '状态',
		nomore: '没有更多了',
		More: '更多',
		SeeMore: '查看更多',
		Detail: '查看详情',
		Changebatch: '换一批',
		Lovely: '猜你喜欢',
		selplatform: '选择平台',
		betamount: '投注金额',
		betgame: '游戏',
		betresult: '投注结果',
		perfect1: '完善账户信息，更安全',
		perfect2: '完善个人资料',
		perfect3: '资料更完整，我们的服务更加周到',
		perfect4: '去完善',
		binding: '绑定',
		AddBinding: '新增绑定',
		carding1: '卡片管理',
		carding2: '如需提现，请绑定银行卡或虚拟币地址',
		logpassword1: '登录密码',
		logpassword2: '定期修改登录密码，有利账户安全',
		paypassword1: '支付密码',
		paypassword2: '定期修改支付密码，有利账户安全',
		oldloginpass: '原登录密码',
		newloginpass: '新登录密码',
		oldloginpassdesc: '请输入原登录密码',
		newloginpassdesc: '请输入新登录密码',
		confirmpass: '确认密码',
		confirmpassdesc: '请输入确认密码',
		oldpaypass: '原支付密码',
		newpaypass: '新支付密码',
		oldpaypassdesc: '请输入原支付密码',
		newpaypassdesc: '请输入新支付密码',
		personalinformation: '编辑资料',
		edit: '编辑',
		SelectAll: '全选',
		Delete: '删除',
		avatar: '上传头像',
		username: '用户',
		userID: '用户ID',
		userIDdesc: '请输入用户ID',
		username1: '用户名',
		realname: '姓名',
		nickname: '昵称',
		realname2: '真实姓名',
		realname1: '姓名或昵称',
		realname1desc: '请输入姓名或昵称',
		realnamedesc: '请输入姓名',
		nicknamedesc: '请输入昵称',
		sex: '性别',
		birthday: '生日',
		birthdaydesc: '请选择生日',
		email: '邮箱',
		phone: '手机号',
		nationality: '国籍',
		nationalitydesc: '请输入国籍',
		education: '学历',
		educationdesc: '请输入学历',
		AnnualSalary: '年薪',
		AnnualSalarydesc: '请输入年薪',
		work: '工作',
		workdesc: '请输入工作',
		RegistrationTime: '注册时间',
		LastLogin: '最后登录',
		operate: '操作',
		mail: '站内信',
		allplat: '全平台',
		upgrade: '升级',
		draw: '领取',
		Received: '已领取',
		totaldraw: '累计领取',
		undraw: '待领取',
		transin: '转入',
		transout: '转出',
		transtype: '选择交易类型',
		walfareinfo: '红包情况',
		help1: 'Hi,尊敬的会员用户',
		help2: '欢迎来到帮助中心',
		help3: '若相关问题仍未解决，可咨询在线客服',
		ungot: '未达标',
		got: '已达标',
		totalrecharge: '累计充值',
		totalwater: '累计流水',
		waterratio: '返水比例',
		jinji: '晋级',
		lijin: '礼金',
		level: '等级',
		hot: '热门',
		live: '真人',
		slot: '电子',
		chess: '棋牌',
		sports: '体育',
		lottery: '彩票',
		fishing: '捕鱼',
		actrules: '活动规则',
		accountlogin: '账号密码登录',
		mobilelogin: '手机快捷登录',
		password: '密码',
		newpassword: '新密码',
		pleaseaccount: '请输入账户名',
		passtips: '密码长度6-15个字符，必须由字母及数字组成！',
		pleasepass: '请输入密码',
		pleasetwcode: '请输入图文验证码',
		country: '国家/手机号',
		pleasemobile: '请输入手机号',
		yzm: '验证码',
		pleaseyzm: '请输入手机验证码',
		sendcode: '发送验证码',
		currency: '币种',
		usernametips: '请输入 4-16位字符，含英数',
		currencytips: '请选择币种',
		againpass: '再次输入以上密码',
		ckmoney: '存款金额',
		ckdate: '存款日期',
		redmoney: '红包金额',
		activitycenter: '活动',
		lucrative: '推广',
		MemberManagement: '会员管理',
		CommissionSettlement: '佣金结算',
		CommissionRecords: '佣金记录',
		FriendTransfer: '好友转账',
		nightMode: '深夜模式',
		Mobileauth: '手机认证',
		Certified: '已认证',
		nodata: '没有数据啦',
		Sportslive: '体育直播',
		MemberID: '会员ID',
		MemberIDdesc: '请输入会员ID',
		friendID: '好友ID',
		friendIDdesc: '请输入好友ID或手机号码',
		findMember: '找回会员',
		Platformfees: '平台费用',
		PromotionalMaterials: '推广素材',
		copylink: '复制链接地址',
		SaveQRcode: '保存二维码',
		interest: '关注',
		eliminate: '剔除',
		Recommend: '推荐',
		new: '新',
		searchfor: '搜索',
		searchfordesc: '请输入搜索内容',
		find: '找到',
		results: '结果',
		Cashier: '收银台',
		skip: '跳过',
		Enterimmediately: '马上进入',
		APPlock: 'APP应用锁',
		actTime: '活动时间',
		confirm: '确定',
		platformtype: '平台类型',
		orderState: '订单状态',
		gameName: '游戏名称',
		gameNamedesc: '请输入游戏名称',
		bettime: '下注时间',
		validamount: '下注金额',
		winloss: '中奖金额',
		betnum: '游戏单号',
		normal: '正常',
		abnormal: '非正常',
		betTotal: '下注总金额',
		winTotal: '中奖总金额',
		Orderamount: '下单金额',
		Orderbet: '下单注量',
		male: "男",
		female: "女",
		electron: "电子游戏",
		Dailyvideo: "每日视频推荐",
		Choicevideo: "精选推荐",
		videoList1: "每日最新更新",
		videoList2: "人气最佳视频",
		videoList3: "免费视频", //短視頻
		mydata1: "影视VIP剩余天数",
		mydata2: "待领取返水金额",
		waterAmount: "返水金额",
		waterDate: "返水日期",
		noblet1: '升级VIP立即全站高清无限看',
		noblet2: '先到先得快来抢购吧',
		noblet3: '无限看，赠送',
		noblet4: '查看购买VIP记录',
		noblet5: '点击此处',
		order1: '次',
		Transamount: '可转出金额',
		Dailylimit: '单日限额',
		vipIDdesc: '请输入会员ID或手机号码',
		Transferaccount: '转入账号',
		Transfermoney: '转入金额',
		Transfert1: '注：参与优惠活动，提款限制将无法到账',
		Transfert2: '注：提交成功后，系统将在10分钟内到账，如若未到账请联系客服',
		amount: '金额',
		receiptTime: '到账时间',
		Transferfriends: '转出好友',
		Transferringfriends: '转入好友',
		Descriptive: '描述信息',
		exchangerate: '实时汇率',
		Accountbalance: '账户余额',
		withdrawal: '提现所需打码量',
		commission: '手续费',
		Exchangerate: '汇率计算',
		illustrate: '说明',
		withdrawtilt1: '最低提现100起，如未到账请及时联系在线客服。',
		withdrawtilt2: '提款银行卡必须是本人银行卡，否则无法到账。',
		tips: '提示',
		findvipt1: '通过此功能可以找回没有绑定成功的下级会员。',
		findvipt2: '限绑定注册时间3天内的下级会员。',
		Totalplatformcost: '平台总费用',
		Winlamount: '输赢金额',
		PlatformRate: '平台费率',
		totalExpenses: '费用总额',
		commission1: '当前佣金比例',
		commission2: '佣金比例',
		Mycommission: '我的佣金',
		totalRecharge: '充值总额',
		totalWithdraw: '提现总额',
		totalPeople: '会员人数',
		activePeople: '活跃会员',
		addPeople: '本月新增',
		SettlementDate: '结算日期',
		DayMonth: '日 / 月',
		ImmeSettle: '立即结算',
		Formula: '计算公式',
		SettleMoney: '已领取佣金金额',
		Date: '日期',
		authname: '认证姓名',
		authnamedesc: '请填写汇款人姓名',
		hashelp: '如需帮助',
		contact: '联系客服',
		Agreement: '协议/币种',
		ckNumber: '存款个数',
		cbaddress: '充币地址',
		notes: '备注',
		Scancoins: '扫码充币',
		content: '内容',
		ckdesc: '请输入存款详情',
		zfAccount: '支付账户',
		zfbank: '支付银行',
		banktype: '充值类型',
		banktypedesc: '请选择充值类型',
		zzzh: '转出账户',
		zjzh: '转入账户',
		whole: '全部',
		zzmoney: '转账金额',
		zhtime: '转账时间',
		zzpt: '转账平台',
		Paymentmethod: '支付方式',
		behalf: '好友代付',
		saccountdesc: '请选择收款账户',
		cztips: '请转账金额到以上账户再提交表单，工作人员将第一时间为您办理。',
		currency1: '货币',
		exchangeRate1: '汇率',
		Rebate: '返利',
		Receive1: '充值到账',
		PaymentVoucher: '上传支付凭证',
		DepositTime: '存款时间',
		DepositTimedesc: '请选择存款时间',
		BlockchainID: '区块链ID',
		BlockchainIDdesc: '请输入区块链ID',
		tradeID: '交易ID后六位',
		tradeIDdesc: '请输入交易ID后六位',
		withdraw1: '提现到账',
		gamenoIndesc: '游戏维护中，请稍后再试~',
		cznamedesc1: '首次在线充值，必须绑定真实姓名。',
		cznamedesc2: '请确保此姓名与存款人姓名一致，否则无法到账。',
		cznamedesc3: '提交保存后，不可更改，请仔细填写。',
		txnamedesc1: '首次绑定信息，必须绑定真实姓名。',
		txnamedesc2: '请确保此姓名与提款人姓名一致，否则无法到账。',
		txnamedesc3: '提交保存后，不可更改，请仔细填写。',
		modify: '修改',
		inviteId: '邀请码',
		findpaypass: '找回支付密码',
		Movies: '影视',
		rakeback: '返水',
		rescue: '救援',
		RedeemCode: '兑换码',
		dhTitle: '我的兑换记录',
		dhtxt: '兑换',
		dhtxtbtn: '立即兑换',
		dhtxtdesc: '输入兑换码',
		dhmoney: '兑换金额',
		dhlsbs: '流水倍数',
		lqtime: '领取时间',
		free: '免费',
		zznamedesc1: '请务必填写转账人真实姓名，否则无法自动到账。',
		zznamedesc2: '若10分钟内，充值金额未到账，请联系在线客服。',
		tgrs: '当前推广人数',
		tglink: '推广链接',
		tgyqewm: '邀请二维码',
		wxts: '温馨提示',
		tgtips1: '申请独立域名，请联系代理专员.',
		tgtips2: '若您是站长, 需要广告素材,请联系客服.',
		tgtips3: '邀请好友注册,只需让您的好友在注册时填写邀请码即可.',
		mycenter: '个人中心',
		myInfo: '个人信息',
		mylucrative: '我的推广',
		Security: '账户安全',
		timeframe: '时间范围',
		starttime: '开始时间',
		endtime: '结束时间',
		Keysdesc: "请选择国家",
		Keysdesc1: "请选择区码",
		rule1: '已满21周岁，并且阅读及同意',
		rule2: '【规则与条款】',
		autotrans:'自动免转',
		autotranstips:'游戏时，余额将自动转入对应游戏账户',
		handtrans:'手动转账',
		handtranstips:'如需手动转账，请关闭【自动免转】',
		jytype:'交易类型',
		wechat:'微信',
		Alipay:'支付宝',
		yjed:'佣金额度',
		yjsed:'已结算的额度',
	},
	footer: {
		fkfs: '付款方式',
		partners: '合伙人',
		followUs: '关注我们',
		regauth: '监管机构',
		pagcor: 'PAGCOR',
		legalage: '法定年龄',
		cs: '客服',
		telegram: '飞机',
		network: '网络',
		dark: '夜间',
		byday: '白天',
		affiliate: '关联',
		TOP: '顶部',
		chat: '聊天',
	},
	home: {
		hotgametit: "热门游戏",
		activitydesc1: "腾达超级礼遇",
		activitydesc2: "呼朋唤友彩金齐齐赚",
		new: "最新",
		Chesscardsdesc1: "国际棋牌",
		Chesscardsdesc2: "逼真的游戏体验，",
		Chesscardsdesc3: "逼真的人工智能，",
		Chesscardsdesc4: "多种模式和新的游戏方式",
		Chesscardsdesc5: "高端棋牌游戏，超级火爆平台..",
		lotterydesc1: "彩票",
		lotterydesc2: "与经典和创新的彩票游戏，",
		lotterydesc3: "这将增加欲望的游戏过程",
		onsitedesc1: "LIVE CASINO",
		onsitedesc2: "我们秉持着「服务至上」的理念，致力于为广大的会员玩家们提供",
		onsitedesc3: "最丰富的线上博彩游戏及多元化高值量的服务系统",
		placeholderdesc: "请输入游戏名称",
		gogamebtn: "进入游戏",
		swgamebtn: "试玩游戏",
		swbtn: "试玩",
		egamesdesc1: "掌上游戏软件",
		egamesdesc2: "全球领先的电子游戏供应商，",
		egamesdesc3: "主要从事线下和线上电子游戏开发。",
		egamesdesc4: "拥有亚洲最大的娱乐城市",
		livedesc1: "Casino Live",
		livedesc2: "AG ALLBET  OG DS ",
		livedesc3: "顶级娱乐平台",
		livedesc4: "龙虎、炸金花、色碟、番摊等玩法桌台任君挑选，",
		livedesc5: "让您拥有身临其境的奢华体验！",
		sportdesc1:"体育",
		sportdesc2:"大多数类型的投注，最强的投注体验，",
		sportdesc3:"支持提前套现，",
		sportdesc4:"收集大米快一步，想想你的想法，",
		sportdesc5:"投票给你喜欢的人。",
		fishdesc1:"捕鱼",
		fishdesc2:"疯狂钓鱼！超高爆炸",
		fishdesc3:"速率，巨大的宝藏等着你去抓！",
		tiptitle: '重要提醒',
		tipclose: '关闭',
		tipflag: '今日不提醒',
		testdesc1: "最新官方网址",
		testdesc2: "温馨提示: 最小MS数值的网址打开速度就越快！",
		LinkTimeout: "链接超时",
		GoImmediately: "立即前往",
		Recheck: "重新检查访问速度",
		Enter:'进入',
	},
	help: {
		title0: '关于我们',
		title1: '常见问题',
		title2: '隐私政策',
		title3: '免责声明',
		title4: '联系我们',
		title5: '代理加盟',
		title6: '博彩责任',
		title7: '商务合作',
		service: '在线客服',
		servicedesc: '快速，便捷，及时提供沟通',
	},
	download: {
		scantxt: '扫描二维码下载APP',
		downtext: "APP下载",
		downdesc: "立即开立TDBET账户并享受最优惠的奖金！",
		version: "版本",
		ScanCodedown: "扫码下载APP",
		BeCurrent: "通用",
		H5org: "H5页面访问",
	},
	vip: {
		viptitle: "腾达VIP",
		viptitle1: "巅峰盛典",
		viptitle2: "荣耀起航",
		viptitle3: "加入腾达VIP 享顶级至尊服务",
		vipen: "BECOME A VIP MEMBER AND ENJOY THE MOST HONORBLE SERVICE",
		totalDeposit: "累计充值",
		totalBet: "累计流水",
		vipBLdesc: "VIP返水比例",
		vipgradetitle: "VIP等级",
		vipgrade1: "真人返水",
		vipgrade2: "电子返水",
		vipgrade3: "棋牌返水",
		vipgrade4: "体育返水",
		vipgrade5: "彩票返水",
		vipgrade6: "电竞返水",
		ActivityRules: "活动规则",
		Rulestext1: "晋升标准",
		Rulesdesc1: "会员的累计存款以及累计流水达到相应级别的要求，即可在次日24点前晋级相应VIP等级。",
		Rulestext2: "晋升顺序",
		Rulesdesc2: "VIP等级达到相应的要求可每天晋升一级，但VIP等级不可越级晋升。",
		Rulestext3: "保级要求",
		Rulesdesc3: "会员在达到某VIP等级后，90天内投注需要完成保级流水要求。如果在此期间完成晋升，保级要求重新按照当前等级计算。",
		Rulestext4: "降级标准",
		Rulesdesc4: "如果会员在一个季度（90天计算）内没有完成相应的保级要求流水，系统会自动降级一个等级，相应的返水及其它优惠也会随之调整至降级后的等级。",
		Rulestext5: "升级礼金",
		Rulesdesc5: "升级礼金在会员达到该会员级别后系统自动派发，每个级别的升级礼金每位会员仅能获得1次（升级礼金1倍流水即可提款）。",
		Rulestext6: "生日礼金",
		Rulesdesc6: "会员在注册三个月内过生日，今年将不能领取生日礼金。另注册时间大于三个月的会员需在生日当天的VIP页面进行自助领取，每年可领取一次。（生日礼金1倍流水即可提款）。",
		Rulestext7: "每月红包",
		Rulesdesc7: "会员在上个月有过至少1次的存款成功记录，即可在次月1号和16号分别前往VIP页面领取当天相应等级的每月红包彩金的1/2（红包礼金1倍流水即可提款）",
		Rulestext8: "腾达娱乐 娱乐保留对活动的修改，停止及最终解释权。",
		Rulesdesc8: "备注：以上为各场馆最高返水，具体返水金额请以实际游戏为准，每日返水将在次日的15:00 - 16:00陆续进行发放。",

	},
}


// WEBPACK FOOTER //
// ./src/lang/zh_cn.js